import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedDetailMeasurement from './helpers/PdpSharedDetailMeasurement';

// helpers
import get from 'lodash.get';

function PdpSharedDetailWaist({ item }) {
    return (
        <PdpSharedDetailMeasurement
            dataTn="pdp-spec-waist"
            measurements={get(item, 'measurement.waist')}
        />
    );
}

PdpSharedDetailWaist.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailWaist, {
    item: graphql`
        fragment PdpSharedDetailWaist_item on Item {
            measurement {
                waist: display(fields: [waist]) {
                    ...PdpSharedDetailMeasurement_measurements
                }
            }
        }
    `,
});
